import { render, staticRenderFns } from "./OPicture.vue?vue&type=template&id=511ce8e8&scoped=true&"
import script from "./OPicture.vue?vue&type=script&lang=js&"
export * from "./OPicture.vue?vue&type=script&lang=js&"
import style0 from "./OPicture.vue?vue&type=style&index=0&id=511ce8e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ce8e8",
  null
  
)

export default component.exports